/* src/app/service-distributor/service-distributor-details/service-distributor-details.component.scss */
body {
  margin-left: 250px;
  overflow-y: auto;
}
.top-container {
  display: flex;
  padding: 18px 0px 24px 0px;
  flex-direction: column;
  border-radius: 0px 0px 24px 24px;
  background: var(--Gray-100, #F2F4F7);
}
.top-content {
  gap: 16px;
}
.custom-button {
  background-color: #FF8C00;
  border: #FF8C00;
}
.btn-1 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  height: 40px;
}
.btn-2 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 10px 16px;
  border: 1px solid #D0D5DD;
  cursor: pointer;
  background-color: #fff;
  height: 40px;
}
.btn-1:hover,
.btn-2:hover,
.btn-mark-disable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-warning-1 {
  background-color: white;
  color: #B42318;
  border: 1px solid #B42318;
}
.btn-contrast-1 {
  background-color: #fff;
  color: #000;
  border: 1px solid #D0D5DD;
}
.outlined-1 {
  background-color: #fff;
  color: #B42318;
  border-color: #B42318;
}
.outlined {
  background-color: transparent;
  color: #333;
  border-color: #333;
}
.small-1 {
  font-size: 14px;
  padding: 4px 8px;
}
.card-top {
  border-radius: 10px;
  background: white;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: space-between;
  padding: 14px;
}
.rejection-note-card {
  border-radius: 10px;
  background: white;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: space-between;
  padding: 14px;
  margin-top: 15px;
  display: block;
}
.rejection-note-card h3 {
  font-size: 18px;
  color: #101828;
  font-weight: 500;
}
.rejection-note-card p {
  color: #667085;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.subtype-container {
  display: flex;
}
.subtype-container .subtype-card p {
  padding-right: 35px;
}
.subtype-container .subtype-name {
  color: #475467;
  font-size: 14px;
}
.subtype-container .subtype-count {
  font-size: 24px;
  text-align: start;
  margin-top: 6px;
}
.agreement {
  margin-top: 20px;
  font-size: 14px;
  color: #026aa2;
  line-height: 20px;
}
.image {
  width: 370px;
  height: 280px;
  flex: 1 1 0;
  border-radius: 12px;
}
.text {
  width: 65px;
  flex: 2 1 0;
}
.main-text {
  text-align: start;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  width: 385px;
}
.secondary-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--Gray-500, #667085);
}
.business-details {
  width: auto;
  height: 75px;
  margin-top: 65px;
}
.owner {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.user-info {
  display: flex;
  align-items: self-start;
  margin-top: 16px;
}
.username {
  font-size: 16px;
  font-weight: 500;
  color: #101828;
  margin-left: 12px;
}
.name {
  margin: 0;
}
.email {
  margin: 0;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.icon-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #F2F4F7;
  overflow: hidden;
}
.badge {
  background-color: #EEF4FF;
  color: white;
  padding: 1.5px;
  border-radius: 12px;
  height: 22px;
}
.row-container {
  display: flex;
  align-items: flex-start;
}
.main-part {
  padding: 32px 0px 40px 0px;
  border-bottom: 1px solid #EDEDED;
}
.business-info {
  margin-top: 40px;
}
.business-type-label {
  color: #475467;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
  margin-bottom: 8px;
}
.business-type-value {
  font-size: 16px;
  color: #101828;
  font-weight: 500;
  margin: 0;
}
.business-type-web {
  font-size: 16px;
  color: #026AA2;
  font-weight: 500;
  margin: 0;
  cursor: pointer;
}
.service-container div {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.service-column {
  display: flex;
  flex-direction: column;
}
.service-item {
  margin: 5px;
}
.service-name {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
  line-height: 24px;
}
.icon-circle-1 {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  background-color: #D1FADF;
  border-radius: 50%;
  color: white;
  margin-right: 8px;
}
.employee-value {
  font-size: 24px;
  color: #101828;
  font-weight: 500;
  margin: 0;
  margin-top: 4px;
  margin-bottom: 40px;
}
::ng-deep .p-dialog-mask {
  background-color: rgba(8, 12, 20, 0.7);
  backdrop-filter: blur(8px);
}
.acceptbtn {
  gap: 12px;
}
.history {
  right: 20px;
  top: 306px;
}
.historycontain {
  display: flex;
  justify-content: space-between;
}
.no-underline {
  text-decoration: none;
}
.no-underline:hover {
  text-decoration: underline;
}
::ng-deep .p-button.p-button-text:not(:disabled):hover {
  background-color: #fff;
}
.extraspace {
  height: 40px;
}
.btn-toggle {
  background-color: transparent;
  border: none;
  color: #FF8C00;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  text-align: left;
}
.btn-toggle:hover {
  text-decoration: underline;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  height: 30px;
  width: 100px;
}
.tag.submitted {
  background-color: #FFF1E0;
  color: #D47500;
  justify-content: space-around;
}
.tag.submitted::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 2px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.approved {
  background-color: #ECFDF3;
  color: #027A48;
  justify-content: space-around;
}
.tag.approved::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 0px;
  border-radius: 50%;
  background-color: #4caf50;
}
.tag.inreview {
  background-color: #f4f4f4;
  color: #757575;
  justify-content: space-around;
}
.tag.inreview::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background-color: #757575;
}
.tag.rejected {
  background-color: #FFEAEB;
  color: #FF474D;
  justify-content: space-around;
}
.tag.rejected::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #FF474D;
}
.btn-mark-disable {
  background: white;
  color: #B42318;
  border: 1px solid #FDA29B;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  margin-right: 12px;
  font-size: 14px;
}
.snapshots-container {
  display: flex;
  justify-content: space-between;
  background: #f3f4f6;
  padding: 15px;
  border-radius: 10px;
  margin-top: 20px;
  gap: 20px;
}
.snapshot-card {
  flex: 1;
  text-align: center;
  padding: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
}
.snapshot-card h4 {
  font-size: 14px;
  color: #6b7280;
}
.snapshot-card p {
  font-size: 20px;
  font-weight: bold;
  margin-top: 5px;
}
.invalid-tax {
  border: 1px solid red !important;
}
::ng-deep .footer {
  margin-top: 30px;
  padding: 0px;
}
.btn {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  height: 40px;
  width: 100px;
}
.delete-btn {
  background-color: white;
  color: #B42318;
  border: 1px solid #B42318;
}
.delete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-cancel {
  background-color: white;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.review-heading {
  font-size: 20px;
  color: #000;
  font-weight: 600;
}
::ng-deep .p-timeline {
  align-items: flex-start;
}
::ng-deep .p-timeline-event-opposite,
.p-timeline-event-content {
  flex: none;
  padding: 0 1rem;
  min-width: 0px;
}
::ng-deep .p-timeline.p-timeline-vertical .p-timeline-event-content {
  padding: 0 16px;
  padding-bottom: 16px;
}
::ng-deep .p-timeline-event-opposite {
  display: none !important;
}
.p-text-secondary {
  display: flex;
  flex-direction: column;
}
.p-text-secondary strong {
  color: #000;
  font-size: 15px;
  margin-bottom: 10px;
}
::ng-deep .p-timeline .p-timeline-event-marker {
  border: 2px solid orange;
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
}
::ng-deep .p-dialog .p-dialog-footer {
  padding: 0px 24px 32px 24px;
}
/*# sourceMappingURL=service-distributor-details.component-ZAMGTAQS.css.map */
